import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  body: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
    width: '80%',
    margin: '0 auto',
  },
  mainContent: {
    flex: 1,
    overflowY: 'auto',
    padding: theme.spacing(2),
  },
  previewBanner: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    backgroundColor: theme.palette.info?.light || '#e3f2fd',
    color: theme.palette.info?.dark || '#0d47a1',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1, 2),
    marginBottom: theme.spacing(2),
    fontSize: 13,
    fontWeight: 500,
  },
  progressHeader: {
    marginBottom: theme.spacing(2),
  },
  progressLabel: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
  },
  stepsRow: {
    display: 'flex',
    gap: theme.spacing(0.5),
  },
  step: {
    height: 4,
    flex: 1,
    borderRadius: 2,
    backgroundColor: theme.palette.divider,
  },
  stepActive: {
    backgroundColor: theme.palette.common.black,
  },
  questionCard: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
  },
  questionStatement: {
    fontSize: 15,
    fontWeight: 400,
    color: theme.palette.text.primary,
    lineHeight: 1.6,
    marginBottom: theme.spacing(2.5),
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
  },
  multipleCorrectHint: {
    fontSize: 13,
    marginBottom: theme.spacing(1.5),
    fontStyle: 'italic',
  },
  alternativesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  alternativeRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    userSelect: 'none',
  },
  alternativeLetter: {
    width: 30,
    height: 30,
    minWidth: 30,
    borderRadius: '50%',
    border: `2px solid ${theme.palette.divider}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 13,
    fontWeight: 700,
    color: theme.palette.common.black,
    flexShrink: 0,
  },
  alternativeContent: {
    fontSize: 14,
    color: theme.palette.text.primary,
    lineHeight: 1.5,
    paddingTop: 5,
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
  },
  navigation: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  prevButton: {
    textTransform: 'none',
    fontWeight: 500,
    color: theme.palette.text.secondary,
  },
  nextButton: {
    textTransform: 'none',
    fontWeight: 700,
    backgroundColor: theme.palette.common.black,
    color: theme.palette.white,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    '&:disabled': {
      backgroundColor: theme.palette.divider,
      color: theme.palette.text.secondary,
    },
  },
}))

export default useStyles
